// extracted by mini-css-extract-plugin
module.exports = {"userBox":"PayreqUsers_userBox__1wlGz"};